import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-95';
  const variants = {
    primary: 'bg-[#7C4DFF] text-white hover:bg-[#651FFF] shadow-md hover:shadow-lg focus:ring-[#7C4DFF]',
    secondary: 'bg-[#EDE7F6] text-[#7C4DFF] hover:bg-[#D1C4E9] focus:ring-[#B388FF]',
    outline: 'border-2 border-[#7C4DFF] text-[#7C4DFF] hover:bg-[#EDE7F6] focus:ring-[#7C4DFF]',
    ghost: 'text-[#7C4DFF] hover:bg-[#EDE7F6] hover:text-[#651FFF]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-279">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-280" />}
      {children}
    </button>;
}